<div class="page">
  <div class="lb-local-seo">
    <div class="row" *ngIf="(localSEOService.missingGeoLocation$$.asObservable() | async) === true">
      <div class="col col-xs-12">
        <glxy-alert type="warning">
          <div
            [innerHTML]="'LOCAL_SEO.LOCAL_SEO.GEO_NOT_SET' | translate: { redirectLink: listingProfileRedirectLink }"
          ></div>
        </glxy-alert>
      </div>
    </div>
    <div class="row row-gutters" *ngIf="(localSEOService.missingWebsite$$.asObservable() | async) === true">
      <div class="col col-xs-12">
        <glxy-alert type="warning">
          <div
            [innerHTML]="
              'LOCAL_SEO.LOCAL_SEO.WEBSITE_NOT_SET' | translate: { redirectLink: listingProfileRedirectLink }
            "
          ></div>
        </glxy-alert>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col col-xs-12">
        @if (gbpData$ | async; as gbpData) {
          @if (!gbpData?.account?.connectionId) {
            <glxy-alert class="alert-pad alert-pad-listing" type="info">
              <strong>{{ 'LISTING_SYNC.PRIMARY_SOURCES.GMB_AUTH' | translate }}</strong>
              <b
                ><a [href]="gbpData.connectLink" class="btn btn-primary">
                  {{ 'LISTING_SYNC.PRIMARY_SOURCES.GMB_AUTH_BUTTON' | translate }}
                </a></b
              >
            </glxy-alert>
          } @else if (gbpData?.account?.tokenBroken || !gbpData?.account?.isAuthenticated) {
            <glxy-alert
              type="warning"
              [showAction]="true"
              [actionExternalLink]="gbpData.connectLink"
              actionTitle="{{ 'COMMON.RECONNECT_ACCOUNT' | translate }}"
            >
              {{ 'GOOGLE_INSIGHTS.SOCIAL_TOKEN_BROKEN' | translate }}
            </glxy-alert>
          } @else if (!gbpData?.account?.isVerified) {
            <glxy-alert
              type="warning"
              [showAction]="true"
              actionTitle="{{ 'GOOGLE_INSIGHTS.NOT_VERIFIED.VERIFY_LINK' | translate }}"
              [actionExternalLink]="gmbVerifyUrl"
            >
              <strong>{{ 'GOOGLE_INSIGHTS.NOT_VERIFIED.TITLE' | translate }}</strong>
              &mdash; {{ 'GOOGLE_INSIGHTS.NOT_VERIFIED.DESCRIPTION' | translate }}
            </glxy-alert>
          }
        }
      </div>
    </div>

    <div class="row row-gutters">
      <div class="col col-xs-12">
        <local-seo-info-banner
          [title]="'LOCAL_SEO.BANNER.TITLE' | translate"
          [description]="'LOCAL_SEO.BANNER.DESCRIPTION' | translate"
          [imageURL]="
            'https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/keyword-tracking-banner.svg'
          "
        ></local-seo-info-banner>
      </div>
    </div>

    <div class="row row-gutters">
      <div class="col col-xs-12">
        <ng-container *ngIf="SEOData$ | async as data">
          <local-seo-keywords-stats-cards
            [data]="data"
            [keywordMetrics]="keywordMetrics$ | async"
          ></local-seo-keywords-stats-cards>
        </ng-container>
      </div>
    </div>
    <div class="row row-gutters">
      <div class="col col-xs-12 keyword-table-container">
        <ng-container *ngIf="isKeywordListEmpty$ | async">
          <ng-container *ngIf="localSEOService.keywordLimit$ | async as limit">
            <ng-container *ngIf="localSEOService.suggestedKeywords$ | async as suggestedKeywords">
              <button
                [disabled]="!this.canEditKeywords"
                class="keyword-table-container-button"
                (click)="open(limit, suggestedKeywords)"
                mat-flat-button
                color="primary"
              >
                <mat-icon>add</mat-icon>
                {{ 'LOCAL_SEO.ADD_INITIAL_KEYWORD' | translate }}
              </button>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isKeywordListEmpty$ | async; else showTable">
          <ng-container *ngIf="isLbFreeEdition$ | async; then exampleTable; else emptyStatePro"></ng-container>
        </ng-container>
      </div>
    </div>

    <div class="row row-gutters">
      <div class="col col-xs-12">
        <mat-card>
          <div class="legend">
            <div class="legend--label">
              <strong>{{ 'LOCAL_SEO.LEGEND.LABEL' | translate }}</strong>
            </div>
            <div class="item"><strong>50+</strong> {{ 'LOCAL_SEO.LEGEND.OVER_50' | translate }}</div>
            <div class="item"><strong>NR</strong> {{ 'LOCAL_SEO.LEGEND.NOT_RANKED' | translate }}</div>
            <div class="item"><strong>—</strong> {{ 'LOCAL_SEO.LEGEND.SEARCHING' | translate }}</div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
  <div class="footer items-center">
    <p>
      {{ 'COMMON.DISCLAIMER' | translate }}
    </p>
  </div>
</div>

<ng-template #exampleTable>
  <mat-card>
    <table mat-table [dataSource]="ExampleData" class="example-table">
      <ng-container matColumnDef="empty">
        <th mat-header-cell *matHeaderCellDef></th>
      </ng-container>

      <ng-container matColumnDef="local">
        <th mat-header-cell colspan="2" class="divided" *matHeaderCellDef>
          <div class="mat-sort-header-content">
            <img src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/google/google-maps.svg" />
            <div>{{ 'LOCAL_SEO.LOCAL_SEO.MAPS' | translate }}</div>
          </div>
        </th>
      </ng-container>

      <ng-container matColumnDef="organic">
        <th mat-header-cell colspan="2" class="divided" *matHeaderCellDef>
          <div class="mat-sort-header-content">
            <img src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/google/google.png" />
            <div>{{ 'LOCAL_SEO.LOCAL_SEO.ORGANIC' | translate }}</div>
          </div>
        </th>
      </ng-container>

      <ng-container [matColumnDef]="'empty2'">
        <th class="divided" colspan="2" mat-header-cell *matHeaderCellDef></th>
      </ng-container>

      <ng-container matColumnDef="keyword">
        <th mat-header-cell *matHeaderCellDef class="divided">{{ 'LOCAL_SEO.KEYWORD.TITLE' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.keyword | translate }}</td>
      </ng-container>

      <ng-container matColumnDef="mapsRank">
        <th mat-header-cell *matHeaderCellDef class="divided">{{ 'LOCAL_SEO.LOCAL_SEO.RANK' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.mapsRank }}</td>
      </ng-container>

      <ng-container matColumnDef="mapsStartedAt">
        <th mat-header-cell *matHeaderCellDef>{{ 'LOCAL_SEO.LOCAL_SEO.STARTED_AT' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.mapsStartedAt }}</td>
      </ng-container>

      <ng-container matColumnDef="organicRank">
        <th mat-header-cell *matHeaderCellDef class="divided">{{ 'LOCAL_SEO.LOCAL_SEO.RANK' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.organicRank }}</td>
      </ng-container>

      <ng-container matColumnDef="organicStartedAt">
        <th mat-header-cell *matHeaderCellDef>{{ 'LOCAL_SEO.LOCAL_SEO.STARTED_AT' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.organicStartedAt }}</td>
      </ng-container>

      <ng-container matColumnDef="organicDifficulty">
        <th mat-header-cell *matHeaderCellDef class="divided">
          {{ 'LOCAL_SEO.LOCAL_SEO.RANK_DIFFICULTY' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.rankDifficulty }}</td>
      </ng-container>

      <ng-container matColumnDef="searchVolume">
        <th mat-header-cell [innerHTML]="'LOCAL_SEO.LOCAL_SEO.SEARCH_VOLUME' | translate" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">{{ element.searchVolume }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['empty', 'local', 'organic', 'empty2']"></tr>
      <tr
        mat-header-row
        *matHeaderRowDef="[
          'keyword',
          'mapsRank',
          'mapsStartedAt',
          'organicRank',
          'organicStartedAt',
          'organicDifficulty',
          'searchVolume',
        ]"
      ></tr>
      <tr
        mat-row
        *matRowDef="
          let row;
          columns: [
            'keyword',
            'mapsRank',
            'mapsStartedAt',
            'organicRank',
            'organicStartedAt',
            'organicDifficulty',
            'searchVolume',
          ]
        "
      ></tr>
    </table>
  </mat-card>
</ng-template>
<ng-template #showTable>
  <mat-card>
    <local-seo-keyword-table
      [SEOData]="SEOData$ | async"
      [loading$]="loading$"
      [keywordStore]="localSEOService.keywordStore$ | async"
      [emptyStateImageURL]="emptyStateImage$ | async"
      [editionUpgradeHidden]="editionUpgradeHidden$ | async"
      [proActive]="(isLbFreeEdition$ | async) === false"
      [location]="Location$ | async"
      [agid]="agid$ | async"
      [settings]="localSEOService.seoSettings$ | async"
      [disableEditingKeywords]="!this.canEditKeywords"
      (upgradeButtonClicked)="OpenUpgradeDialog()"
      (deleteKeyword)="deleteKeyword($event)"
      (favoriteKeywordsChanged)="localSEOService.updateFavoriteKeywords($event)"
      (syncingKeywordsChanged)="localSEOService.updateSyncingKeywords($event)"
    ></local-seo-keyword-table>
  </mat-card>
</ng-template>
<ng-template #emptyStatePro>
  <img
    class="empty-state"
    src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/keywords-empty-state-pro-edition.svg"
  />
</ng-template>
